const SESSION_STORAGE_KEY = "tema_telemetry_session_id";

export function getTelemetrySessionId() {
  try {
    const existing = sessionStorage.getItem(SESSION_STORAGE_KEY)?.trim();
    if (existing) {
      return existing;
    }

    const nextId =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `session-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

    sessionStorage.setItem(SESSION_STORAGE_KEY, nextId);
    return nextId;
  } catch {
    return `session-${Date.now()}`;
  }
}

export function resetTelemetrySessionIdForTests() {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } catch {
    // ignore storage failures in tests
  }
}
